<div class="SelectCellEditorComponent">
  <mat-form-field class="SelectCellEditorComponent__form-field">
    <mat-label></mat-label>
    <input
      type="text"
      #matSelect
      placeholder="Pick one"
      aria-label="Number"
      matInput
      id="matSelect"
      [formControl]="selectionControl"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete (optionSelected)="onEventSelection()" autoActiveFirstOption #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option.key">
        {{ option.key }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
